export enum NotificationType {
    Success = 1,
    Warning = 2,
    Error = 3
}